export * from './transporter-vehicle-details';
